var map = {
	"./articles.de-CH.json": 1482,
	"./articles.de-DE.json": 1483,
	"./articles.en-CA.json": 1484,
	"./articles.en-GB.json": 1485,
	"./articles.en-IN.json": 1486,
	"./articles.en-ME.json": 1487,
	"./articles.en-US.json": 1488,
	"./articles.es-EM.json": 1489,
	"./articles.es-ES.json": 1490,
	"./articles.fr-BE.json": 1491,
	"./articles.fr-CA.json": 1492,
	"./articles.fr-CH.json": 1493,
	"./articles.nl-BE.json": 1494,
	"./articles.nl-NL.json": 1495,
	"./articles.pl-PL.json": 1496,
	"./articles.pt-BR.json": 1497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1481;